 'use strict';

  const Menu = {
    menuBtn: document.querySelector('.js-menu-btn'),
    menuOuter: document.querySelector('.js-nav-outer'),
    body: document.body,
    classActive: 'is-active',
    classFixed: 'prevent-scroll',

    init() {
        if (!this.menuBtn || !this.menuOuter) return;
            this.bindEvents();
            this.megamenuToggle();
        if (window.innerWidth < 1200) {
            this.linksOnMobileToggle();
            this.stickyHeaderResponsive();
        }
        this.stickyHeaderDesktop();
    },

    bindEvents() {
      this.menuBtn.addEventListener('click', () => {
        this.toggleMenu();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeMenu();
        }
      });

      document.addEventListener('click', (e) => {
        if (
          this.menuBtn.classList.contains(this.classActive) &&
          !this.menuOuter.contains(e.target) &&
          !this.menuBtn.contains(e.target)
        ) {
          this.closeMenu();
        }
      });

      const closeBtns = document.querySelectorAll('.js-site-header__inner-mob-nav-close');
      closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.closeMenu();
        });
      });
    },

    toggleMenu() {
      if (!this.menuBtn.classList.contains(this.classActive)) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    },

    openMenu() {
      this.menuBtn.classList.add(this.classActive);
      this.menuOuter.classList.add(this.classActive);
      this.body.classList.add(this.classFixed);
    },

    closeMenu() {
      this.menuBtn.classList.remove(this.classActive);
      this.menuOuter.classList.remove(this.classActive);
      this.body.classList.remove(this.classFixed);
    },

    megamenuToggle() {
      document.addEventListener('DOMContentLoaded', () => {
        const menuLinks = document.querySelectorAll('.js-menu-link-megamenu');
        const megaMenus = document.querySelectorAll('.js-site-header__megamenu');
        const body = document.querySelector('body');
    
        if (!menuLinks.length || !megaMenus.length) return;
    
        menuLinks.forEach((link, index) => {
          const megaMenu = megaMenus[index];
          if (!megaMenu) return;
    
          const megaMenuInner = megaMenu.querySelector('.js-site-header__megamenu-inner');
          if (!megaMenuInner) return;
    
          link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
    
            megaMenu.classList.toggle('is-active');
            if (window.innerWidth > 1199) {
              body.classList.toggle('prevent-scroll');
            }

            link.classList.toggle('is-active');
          });
    
          megaMenuInner.addEventListener('click', (e) => {
            e.stopPropagation();
          });
    
          megaMenu.addEventListener('click', (e) => {
            if (!megaMenuInner.contains(e.target)) {
              megaMenu.classList.remove('is-active');
              link.classList.remove('is-active');
              if (window.innerWidth > 1199) {
                body.classList.remove('prevent-scroll');
              }
            }
          });
    
          document.addEventListener('click', () => {
            megaMenu.classList.remove('is-active');
            link.classList.remove('is-active');
            if (window.innerWidth > 1199) {
              body.classList.remove('prevent-scroll');
            }
          });
        });
      });
    },

    linksOnMobileToggle() {
      document.addEventListener('DOMContentLoaded', () => {
        const megamenuTitles = document.querySelectorAll('.megamenu-column__main-title');
      
        megamenuTitles.forEach(title => {
          title.addEventListener('click', () => {
            const list = title.nextElementSibling;
            if (!list) return;
      
            list.classList.toggle('is-open');
      
            title.classList.toggle('is-active');
          });
        });
      });
    },

    stickyHeaderDesktop() {
      document.addEventListener('DOMContentLoaded', () => {
        const stickyHeader = document.querySelector('.header-sticky');
      
        if (!stickyHeader) return;
      
        function handleStickyHeader() {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
      
        if (scrollTop > 0) {
            stickyHeader.classList.add('is-visible');
        } else {
            stickyHeader.classList.remove('is-visible');
        }
        }
      
        window.addEventListener('scroll', handleStickyHeader);
        window.addEventListener('resize', handleStickyHeader);

        handleStickyHeader();
      });
    },

    stickyHeaderResponsive() {
      const header = document.querySelector('.wls-header');
      if (!header) return;

      function handleScroll() {
        if (window.innerWidth < 1200) {
          if (window.scrollY > 0) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }
        } else {
          header.classList.remove('sticky');
        }
      }

      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);

      handleScroll();
    },
  };

  Menu.init();